import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const CartIcon = createSvgIcon(
  <>
    <path
      d="M21.6384 10.4891C22.3578 8.72638 22.8142 6.86744 22.9929 4.97194C23.0848 4.0006 22.2847 3.20764 21.3099 3.20764H5.33936L6.25771 8.88201C6.5703 10.8229 7.94607 12.4177 9.8958 12.6685C11.2653 12.8416 12.6445 12.9254 14.0249 12.9192C16.3508 12.9192 18.0656 12.6985 19.1959 12.4777C19.7364 12.3759 20.2429 12.1406 20.6695 11.7933C21.096 11.4461 21.429 10.9978 21.6384 10.4891Z"
      {...strokeProps}
    />
    <path
      d="M20.4267 17.3361H10.6286C9.78984 17.336 8.9785 17.0374 8.33976 16.4938C7.70102 15.9502 7.27657 15.1971 7.14237 14.3691L5.45402 3.96699C5.31982 3.13905 4.89537 2.38588 4.25663 1.84227C3.61789 1.29867 2.80655 1.0001 1.9678 1H1M8.68945 21.2886C8.956 21.2998 9.22207 21.2571 9.47167 21.1628C9.72126 21.0686 9.94921 20.9248 10.1418 20.7402C10.3344 20.5556 10.4876 20.3339 10.5923 20.0885C10.697 19.8431 10.751 19.5791 10.751 19.3123C10.751 19.0455 10.697 18.7815 10.5923 18.5361C10.4876 18.2907 10.3344 18.0691 10.1418 17.8844C9.94921 17.6998 9.72126 17.5561 9.47167 17.4618C9.22207 17.3676 8.956 17.3248 8.68945 17.3361C8.17977 17.3577 7.69813 17.5753 7.34512 17.9435C6.99211 18.3118 6.79502 18.8022 6.79502 19.3123C6.79502 19.8225 6.99211 20.3129 7.34512 20.6811C7.69813 21.0494 8.17977 21.267 8.68945 21.2886Z"
      {...strokeProps}
    />
    <path
      d="M20.4267 21.2886C20.6932 21.2998 20.9593 21.2571 21.2089 21.1628C21.4585 21.0686 21.6864 20.9249 21.879 20.7402C22.0716 20.5556 22.2249 20.3339 22.3295 20.0886C22.4342 19.8432 22.4882 19.5791 22.4882 19.3123C22.4882 19.0456 22.4342 18.7815 22.3295 18.5361C22.2249 18.2907 22.0716 18.0691 21.879 17.8845C21.6864 17.6998 21.4585 17.5561 21.2089 17.4618C20.9593 17.3676 20.6932 17.3248 20.4267 17.3361C19.917 17.3577 19.4353 17.5753 19.0823 17.9436C18.7293 18.3118 18.5322 18.8022 18.5322 19.3123C18.5322 19.8225 18.7293 20.3129 19.0823 20.6811C19.4353 21.0494 19.917 21.267 20.4267 21.2886Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'CartIcon', viewBox: '0 0 24 23' }
);
